import React, { useEffect } from "react";
import {useLocation, useMatch, useParams} from "react-router-dom";
import Facebook from "@lumen-developer/lumen-socials/dist/Facebook";
import Instagram from "@lumen-developer/lumen-socials/dist/Instagram";
import Pinterest from "@lumen-developer/lumen-socials/dist/Pinterest";
import TikTok from "@lumen-developer/lumen-socials/dist/TikTok";
import Douyin from "@lumen-developer/lumen-socials/dist/Douyin";
import Xiao from "@lumen-developer/lumen-socials/dist/Xiao";
import Abema from "@lumen-developer/lumen-socials/dist/Abema";
import Video from "@lumen-developer/lumen-socials/dist/Video";
import Videoland from "@lumen-developer/lumen-socials/dist/Videoland";
import ITVX from "@lumen-developer/lumen-socials/dist/ITVX";
import Tencent from "@lumen-developer/lumen-socials/dist/Tencent";
import Iq from "@lumen-developer/lumen-socials/dist/Iq";
import TVer from "@lumen-developer/lumen-socials/dist/TVer";
import Snapchat from "@lumen-developer/lumen-socials/dist/Snapchat";
import Gmail from "@lumen-developer/lumen-socials/dist/Gmail"
import Twitter from "@lumen-developer/lumen-socials/dist/Twitter"
import Music from "@lumen-developer/lumen-socials/dist/Music"
import Article from "@lumen-developer/lumen-socials/dist/Article"
import Trainline from "@lumen-developer/lumen-socials/dist/Trainline"
import Uber from "@lumen-developer/lumen-socials/dist/Uber"
import UberEats from "@lumen-developer/lumen-socials/dist/UberEats"
import LinkedIn from "@lumen-developer/lumen-socials/dist/LinkedIn"
import F0F from "../errors/404";

// We need to lazy initialize these components so they do not override their styles with each other.
// Also due to switch over the social site name, there will only ever be one of these components loaded at a time
// so lazy loading makes sense even for the rest of the sites in the future.
const YouTube = React.lazy(() => import('@lumen-developer/lumen-socials/dist/YouTube'));
const Twitch = React.lazy(() => import('@lumen-developer/lumen-socials/dist/Twitch'));
const YouTubeShorts = React.lazy(() => import('@lumen-developer/lumen-socials/dist/YouTubeShorts'));

const Socials = () => {
    let { socialsitename, id } = useParams();
    const location = useLocation();
    const newPersona = useMatch("/:socialsitename/view2/:id/*")

    // We need to get video site manually because if it is set as param the sites which do not use it wont work if they have sub routes
    const pathComponents = location.pathname.split("/");
    let viewComponentIndex
    if (newPersona) {
        viewComponentIndex = pathComponents.findIndex((component) => component === "view2");
    } else {
        viewComponentIndex =  pathComponents.findIndex((component) => component === "view");
    }


    // URL is formatted as /:socialsitename/view/:id/:videoSite
    // This means that the video site is always 2 indexes after the view component
    // If it is not found, it will be undefined
    const videoSite = pathComponents.at(viewComponentIndex + 2);

    useEffect(() => {

        let urlParams = new URLSearchParams(window.location.search);

        let testPrompts = urlParams.get("test_prompts");

        if (!!testPrompts) {
            window.LRIsReady = true
            window.LRhandleStepEnd = () => {
                console.log('Moving to next step!')
            }
        }
    }, [socialsitename]);

    switch (socialsitename) {
        case "pinterest":
            return (
                <Pinterest
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Pinterest>
            );
        case "instagram":
            return (
                <Instagram
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Instagram>
            );
        case "facebook":
            return (
                <Facebook
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Facebook>
            );
        case "linkedin":
            return (
                <LinkedIn
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></LinkedIn>
            );
        case "twitter":
            return (
                <Twitter
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Twitter>
            );
        case "music":
            return (
                <Music
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Music>
            );
        case "article":
            return (
                <Article
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Article>
            );
        case "snapchat":
            return (
                <Snapchat
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Snapchat>
            );
        case "tiktok":
            return (
                <TikTok
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></TikTok>
            );
        case "youtubeshorts":
            return (
                <React.Suspense fallback={<div />}>
                    <YouTubeShorts
                        env={process.env.REACT_APP_ENVIRONMENT}
                        baseURL={process.env.REACT_APP_API_GET}
                        vendorId={"lumen"}
                        personaId={id}
                        screenshotMode={false}
                        handleStepEnd={() => {
                            window.LRhandleStepEnd();
                        }}
                        fullScreen={true}
                        newPersona={newPersona}
                    />
                </React.Suspense>
            );
        case "douyin":
            return (
                <Douyin
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Douyin>
            );
        case "xiao":
            return (
                <Xiao
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Xiao>
            );
        case "video":
            return (
                <Video
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    videoSite={videoSite}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Video>
            );
        case "trainline":
            return (
                <Trainline
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    pageId={videoSite}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Trainline>
            );
        case "uber":
            return (
                <Uber
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    pageId={videoSite}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Uber>
            );
        case "uberEats":
            return (
                <UberEats
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    pageId={videoSite}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></UberEats>
            );
        case "videoland":
            return (
                <Videoland
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Videoland>
            );
        case "itvx":
            return (
                <ITVX
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></ITVX>
            );
        case "tencent":
            return (
                <Tencent
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Tencent>
            );
        case "iq":
            return (
                <Iq
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Iq>
            );
        case "abema":
            return (
                <Abema
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></Abema>
            );
        case "tver":
            return (
                <TVer
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                ></TVer>
            );
        case "gmail":
            return (
                <Gmail
                    env={process.env.REACT_APP_ENVIRONMENT}
                    baseURL={process.env.REACT_APP_API_GET}
                    vendorId={"lumen"}
                    personaId={id}
                    screenshotMode={false}
                    handleStepEnd={() => {
                        window.LRhandleStepEnd();
                    }}
                    fullScreen={true}
                    newPersona={newPersona}
                >
                </Gmail>
            )
        case "youtube":
            return (
                <React.Suspense fallback={<div />}>
                    <YouTube
                        env={process.env.REACT_APP_ENVIRONMENT}
                        baseURL={process.env.REACT_APP_API_GET}
                        vendorId={"lumen"}
                        personaId={id}
                        screenshotMode={false}
                        handleStepEnd={() => {
                            window.LRhandleStepEnd();
                        }}
                        fullScreen={true}
                    />
                </React.Suspense>
            )
        case "twitch":
            return (
                <React.Suspense fallback={<div />}>
                    <Twitch
                        env={process.env.REACT_APP_ENVIRONMENT}
                        baseURL={process.env.REACT_APP_API_GET}
                        vendorId={"lumen"}
                        personaId={id}
                        screenshotMode={false}
                        handleStepEnd={() => {
                            window.LRhandleStepEnd();
                        }}
                        fullScreen={true}
                    />
                </React.Suspense>
            )
        default:
            return <F0F />;
    }
};

export default Socials;
